class CarolQuote extends HTMLElement {
    static observedAttributes = ["quote-id"];

    constructor() {
        super();
    }

    attributeChangedCallback(_, __, quoteID) {
        const i = setInterval(() => {
            if (window.__TCS__) {
                this.createQuote(quoteID);
                clearInterval(i);
            }
        }, 80);
    }

    createQuote(quoteID) {
        try {
            const id = parseInt(quoteID);
            const { quote, date } = window.__TCS__.QUOTES[id];
            const fullDate = new Date(date);
            const year = fullDate.getFullYear();
            const month = window.__TCS__.MONTHS[fullDate.getMonth()];

            this.innerHTML = `<blockquote class="quote">
    <div>
        <p>${quote}</p>
        <cite>&mdash; Carol (${year}, ${month})</cite>
    </div>
    <div class="quote--icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" height="20" width="20">
            <use href="#quote-icon" fill="#3e3022" />
        </svg>
    </div>
</blockquote>`;
        } catch(_) {
            // Do nothing. It's ok for this to fail.
        }
    }
}

customElements.define("carol-quote", CarolQuote);